(() => {
  if (window.nuSeoEventsLoaded) return;
  window.nuSeoEventsLoaded = true;
  const sourceKey = 'nu_liv:session_source';
  const successKey = 'nu_liv:contact_success';
  const pendingKey = 'nu_liv:contact_type';
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const detectSource = () => {
    const params = new URLSearchParams(location.search);
    const medium = (params.get('utm_medium') || '').toLowerCase();
    const source = (params.get('utm_source') || '').toLowerCase();
    if (params.has('gclid') || params.has('gbraid') || params.has('wbraid')) return 'google_paid';
    if (medium && ['cpc', 'ppc', 'paid', 'paid_social'].includes(medium)) return 'paid_other';
    if (source && ['google', 'bing'].includes(source) && medium === 'organic') return source + '_organic';
    if (medium || source) return 'campaign_other';
    try {
      const host = new URL(document.referrer).hostname.toLowerCase();
      if (host === location.hostname) return null;
      if (/(^|\.)google\.[a-z.]+$/.test(host)) return 'google_organic';
      if (/(^|\.)bing\.com$/.test(host)) return 'bing_organic';
      return 'referral_other';
    } catch (_) { return 'direct'; }
  };
  const assignSource = () => {
    if (!allowed()) { remove(sourceKey); return; }
    if (!read(sourceKey)) write(sourceKey, detectSource() || 'unknown');
    const form = document.getElementById('ContactForm');
    if (!form) return;
    let field = form.querySelector('[name="contact[Enquiry source]"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'contact[Enquiry source]';
      form.append(field);
    }
    field.value = read(sourceKey) || 'unknown';
  };
  const publish = (name, data) => {
    if (!allowed() || !window.Shopify?.analytics?.publish) return Promise.resolve(false);
    try { return Promise.resolve(window.Shopify.analytics.publish(name, data)).catch(() => false); }
    catch (_) { return Promise.resolve(false); }
  };
  const measurementId = 'G-1XGYG1PQ7V';
  let gaConfigured = false;
  let gaOwned = false;
  const sendGa = (name, data) => {
    if (!allowed()) return false;
    if (typeof window.gtag !== 'function') {
      if (!document.head) return false;
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
      window.gtag('js', new Date());
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
      document.head.append(script);
      gaOwned = true;
    }
    if (!gaConfigured) {
      window.gtag('config', measurementId, { send_page_view: false });
      gaConfigured = true;
    }
    window.gtag('event', name, { ...data, send_to: measurementId });
    return true;
  };
  let contactPublishing = false;
  const confirmedContact = () => {
    const marker = read(successKey);
    if (!marker || !/\/pages\/thank-you\/?$/.test(location.pathname)) return;
    if (typeof marker.at !== 'number' || Date.now() - marker.at > 600000) { remove(successKey); return; }
    if (!allowed() || contactPublishing) return;
    contactPublishing = true;
    const type = read(pendingKey);
    const enquiryType = ['Showroom visit', 'Product question', 'Project enquiry'].includes(type) ? type : 'Contact enquiry';
    const payload = { enquiry_type: enquiryType, enquiry_source: read(sourceKey) || 'unknown', event_id: String(marker.at) };
    const gaQueued = sendGa('generate_lead', payload);
    publish('nu_liv:contact_success', payload).then(ok => {
      if (ok || gaQueued) { remove(successKey); remove(pendingKey); }
      contactPublishing = false;
    });
  };
  assignSource();
  const form = document.getElementById('ContactForm');
  form?.addEventListener('submit', () => {
    write('nu_liv:contact_submission', { at: Date.now() });
    assignSource();
    if (allowed()) write(pendingKey, form.querySelector('[name="contact[Enquiry type]"]')?.value || 'Contact enquiry');
  });
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) {
      if (gaOwned) window.gtag('consent', 'update', { analytics_storage: 'denied' });
      remove(sourceKey); remove(pendingKey);
      const field = form?.querySelector('[name="contact[Enquiry source]"]');
      field?.remove();
      return;
    }
    if (gaOwned) window.gtag('consent', 'update', { analytics_storage: 'granted' });
    assignSource(); confirmedContact();
  });
  document.addEventListener('click', event => {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor || !allowed()) return;
    const href = anchor.getAttribute('href') || '';
    let channel;
    if (/^tel:/i.test(href)) channel = 'phone';
    else if (/^https:\/\/(wa\.me|api\.whatsapp\.com)\//i.test(href)) channel = 'whatsapp';
    if (channel) {
      publish('nu_liv:contact_intent', { channel });
      sendGa('contact_intent', { channel });
    }
  });
  let attempts = 0;
  const retry = () => {
    assignSource(); confirmedContact();
    if (++attempts < 12 && (!window.Shopify?.customerPrivacy || (read(successKey) && allowed()))) setTimeout(retry, 250);
  };
  retry();
})();
